import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../api/ApiProvider";
import { KostentraegerUploadDto } from "../../api-client";
import { KostentraegerKeys } from "./kostentraeger.keys";

/** Upload history for the Kostenträgerdateien (derived from blob storage). */
export const useKostentraegerUploads = (enabled: boolean = true) => {
  const { kostentraeger } = useApi();

  return useQuery<KostentraegerUploadDto[]>({
    queryKey: KostentraegerKeys.uploads.all(),
    queryFn: async () => kostentraeger.getKostentraegerUploads(),
    enabled,
    staleTime: 60 * 1000,
    meta: { errorMessage: "Upload-Verlauf konnte nicht geladen werden" },
  });
};
